/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { UseObservableState, useObservable } from '@squiz/dxp-console-support';
import { useMemo } from 'react';
import { Observable } from 'rxjs';
import { EntityMetricStats } from '../../Entities/MetricStats/MetricStats.entity';
import { EntityMetricStatsItem } from '../../Entities/MetricStatsItem/MetricStatsItem.entity';
import { MetricCollectionServiceGetMetricStatsDto } from '../../MetricCollection.service.dto';
import { getMetricCollectionService } from '../../Utilities';

/**
 * The result expected of the useMetricStats hook.
 */
export type useMetricStatsResult = [EntityMetricStatsItem | null, UseObservableState, unknown | null];

/**
 * React hook to get a tenant settings schema by schema ID.
 */
export function useMetricStats(dto: MetricCollectionServiceGetMetricStatsDto): useMetricStatsResult {
  const metricService = getMetricCollectionService();
  const stats$ = useMemo((): Observable<EntityMetricStats | null> => {
    return metricService.getMetricStats(dto);
  }, [dto, metricService]);

  const [stats, error, loading] = useObservable(stats$, [dto], undefined, true);
  return useMemo((): useMetricStatsResult => {
    if (stats) {
      return [stats.data, loading, error as unknown | null];
    }

    return [null, loading, error as unknown | null];
  }, [error, loading, stats]);
}
